/**
 * 接続状態の表示。 色の付いた丸はやめ、 言葉だけで出す。
 * 繋がっているときは何も出さない (異常だけを知らせる)。
 * Play/Result 画面の TitleBar 中央 slot などに置く想定。
 */

import { useRoom } from '../state/room';

export function ConnectionBadge() {
  const reconnecting = useRoom((s) => s.reconnecting);
  if (!reconnecting) return null;
  return (
    <span className="conn-badge conn-badge--warn" role="status">
      再接続しています
    </span>
  );
}
